module.exports = __webpack_public_path__ + "static/media/inverterWrong.38b770fe.png";